<template>
  <div :class="bem()">
    <swiper ref="mySwiper" :options="swiperOption" @resize="update">
      <swiper-slide class="item" v-for="(item, index) in data" :key="index">
        <slot :data="item" :index="index" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import create from '../create'

export default create({
  name: 'scroll-x',
  components: {
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide
  },
  props: {
    data: Array,
    resizeFlag: Boolean
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto'
      },
      tim: null
    }
  },
  mounted() {
    if (this.resizeFlag) {
      window.addEventListener('resize', () => {
        clearTimeout(this.tim)
        this.tim = setTimeout(() => {
          this.slideTo(0, 0)
        }, 100)
      })
    }
  },
  methods: {
    update() {
      setTimeout(() => {
        this.swiper.update()
      }, 500)
    },
    slideTo(index) {
      this.swiper && this.swiper.slideTo(index)
    }
  }
})
</script>

<style lang="scss" src="./index.scss"></style>
